/** Helpers shared by the turn fold (`accumulator.ts`) and the subagent fold. */
import type { ToolCall } from '../types'

export function parseToolInput(input: unknown): Record<string, unknown> {
  if (!input) return {}
  if (typeof input === 'string') {
    let parsed: unknown
    try {
      parsed = JSON.parse(input)
    } catch {
      return {}
    }
    return typeof parsed === 'object' && parsed !== null ? (parsed as Record<string, unknown>) : {}
  }
  return typeof input === 'object' ? (input as Record<string, unknown>) : {}
}

/** Optional tool-call fields forwarded verbatim when the event carries them. */
export function toolCallExtras(event: {
  metadata?: ToolCall['metadata']
  steps?: ToolCall['steps']
  view?: ToolCall['view']
}): Partial<ToolCall> {
  return {
    ...(event.metadata ? { metadata: event.metadata } : {}),
    ...(event.steps ? { steps: event.steps } : {}),
    ...(event.view ? { view: event.view } : {}),
  }
}
